import { OrderModel, OrderPaymentType, SaleDocumentKind, SaleDocumentModel, SplitPaymentState } from "@skylab-shared/dataModel";
import { PaymentMethodItem } from "../../payment-method/queries/payment-method-base.query-base";

export function rewritePaymentMethodFromOrderDocument(source: OrderModel, target: SaleDocumentModel, salePayments: PaymentMethodItem[]): void {
	const map = {
		[OrderPaymentType.ONLINE]: 'FormaPlatnosci_PlatnoscElektroniczna_Nazwa',
		[OrderPaymentType.CASH_ON_DELIVERY]: 'FormaPlatnosci_ZaPobraniem_Nazwa',
		[OrderPaymentType.BANK_TRANSFER]: 'FormaPlatnosci_Przelew_Nazwa',
		[OrderPaymentType.SPLIT_PAYMENT]: 'FormaPlatnosci_Przelew_Nazwa',
	};

	const translationKey = map[source.paymentSummary.paymentType];
	const salePayment = salePayments.find(e => e.translationKey === translationKey);

	if (salePayment) {
		target.paymentMethodId = salePayment.id;
	}
	if ((OrderPaymentType.SPLIT_PAYMENT === source.paymentSummary.paymentType) && target.issuedByVatPayer && (target.kind === SaleDocumentKind.Invoice)) {
		target.splitPayment = SplitPaymentState.Manual;
	}
}